import { Text } from '@react-pdf/renderer'
import { TextValue } from '@ulysses-inc/harami_api_client'
import { FC } from 'react'
import { gridLayoutTableBodyCell } from '../../../shared/styles'

type Props = {
  value?: TextValue
}

export const TableBodyCellText: FC<Props> = ({ value }) => {
  return (
    <Text
      style={[
        gridLayoutTableBodyCell.baseTableBodyCell,
        gridLayoutTableBodyCell.tableBodyCell,
      ]}
    >
      {value?.textValue}
    </Text>
  )
}
